var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslSlideButton, CpslTileButton } from '@usecapsule/react-components';
import { useModalStore, useUserInfoStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { Heading, MainContainer, SecondaryText } from '../common.js';
import { styled } from 'styled-components';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard.js';
import { getMailtoLink } from '../../utils/getMailtoLink.js';
import { useState } from 'react';
export const SaveRecoverySecret = ({ email, value, onComplete, }) => {
    const [isSecretSaved, setIsSecretSaved] = useState(false);
    const [isCopied, copy] = useCopyToClipboard();
    const onCopy = () => {
        copy(value);
        setIsSecretSaved(true);
    };
    const onDownload = () => {
        const element = document.createElement('a');
        const file = new Blob([value], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = 'recovery.txt';
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        setIsSecretSaved(true);
    };
    const onEmail = () => {
        window.open(getMailtoLink(email, value), '_self');
        setIsSecretSaved(true);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(ButtonContainer, { children: [_jsx(StyledCpslTileButton, { icon: isCopied ? 'check' : 'copy', onClick: onCopy, children: _jsx(TileButtonText, { children: isCopied ? 'Copied!' : 'Copy' }) }), _jsx(StyledCpslTileButton, { icon: "downloadCloud", onClick: onDownload, children: _jsx(TileButtonText, { children: "Download" }) }), _jsx(StyledCpslTileButton, { icon: "mail", onClick: onEmail, children: _jsx(TileButtonText, { children: "Email" }) })] }), _jsx(CpslSlideButton, { startIcon: "arrow", endIcon: "check", startText: !isSecretSaved ? 'First, save your recovery secret.' : 'I’ve Saved My Recovery Secret', endText: "OK! Great Job!", onCpslComplete: onComplete, disabled: !isSecretSaved }), _jsx(SliderHelper, { children: !isSecretSaved ? 'Choose an option above.' : 'Slide to complete' })] }));
};
export const RecoverySecretStep = ({ recoveryShare }) => {
    const setStep = useModalStore(state => state.setStep);
    const email = useUserInfoStore(state => state.email);
    const backupDecryptionKey = JSON.parse(recoveryShare || '{}').backupDecryptionKey;
    const onComplete = () => __awaiter(void 0, void 0, void 0, function* () {
        setStep(ModalStep.WALLET_CREATION_DONE);
    });
    return (_jsxs(_Fragment, { children: [_jsxs(StyledMainContainer, { children: [_jsx(Heading, { children: "Your Recovery Secret" }), _jsx(SecondaryText, { children: "Your Recovery Secret allows you to set up a new Passkey in the event you lose access to your current one." })] }), _jsx(SaveRecoverySecret, { email: email, value: backupDecryptionKey, onComplete: onComplete })] }));
};
const StyledMainContainer = styled(MainContainer) `
  margin-top: 4px;
  padding-top: 16px;
  margin-bottom: 0px;
`;
const StyledCpslTileButton = styled(CpslTileButton) `
  --button-icon-color: var(--cpsl-color-text-secondary);
`;
const TileButtonText = styled(SecondaryText) `
  font-size: 8px;
  line-height: 100%;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
`;
const ButtonContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const SliderHelper = styled(SecondaryText) `
  margin-top: -8px;
`;
